import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark, StyledInput } from './BaseInput';
import { handleNumberInputWheel } from './numberInputUtils';

const Input = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  disabled = false,
  required = false,
  error,
  input,
  meta,
  onWheel,
  ...props
}) => {
  // Usar input.value e input.onChange se disponível (React Final Form)
  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name;
  const resolvedValue = type === 'number' ? (fieldValue ?? '') : (fieldValue || '');

  const handleWheel = type === 'number'
    ? (event) => {
        handleNumberInputWheel(event);
        if (onWheel) {
          onWheel(event);
        }
      }
    : onWheel;

  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <StyledInput
        name={fieldName}
        type={type}
        value={resolvedValue}
        onChange={fieldOnChange}
        placeholder={placeholder}
        disabled={disabled}
        onWheel={handleWheel}
        {...props}
      />
      {(error || meta && meta.touched && meta.error) && <ErrorMessage>
          {error || meta.error}
        </ErrorMessage>}
    </FormGroup>;
};

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
export default Input;
